import "./Doc.style.moduleRenamed.css";

export const docContent = "Doc-style-module__docContent___AEGHu";
export const docItem = "Doc-style-module__docItem___V-Wph";
export const docTitle = "Doc-style-module__docTitle___pTLBS";

export default {
  docContent: "Doc-style-module__docContent___AEGHu",
  docItem: "Doc-style-module__docItem___V-Wph",
  docTitle: "Doc-style-module__docTitle___pTLBS",
};